module.exports = __webpack_public_path__ + "static/flags/GA-8a90f7b3aa9ea5f10eac935b5f8923ea.gif";